import { z } from "zod";

/**
 * The agent's task list (the prototype's TodoWrite / `update_todos`): the
 * agent's own queue for a long job, kept by the host so a restart, a
 * condensation or a new turn does not lose it, rendered into the prompt and
 * shown read-only in the details panel so a long turn is legible.
 */

export const TODO_TEXT_MAX_CHARS = 200;
export const TODO_LIST_MAX = 20;

export const TodoStatusSchema = z.enum(["pending", "in_progress", "done"]);
export type TodoStatus = z.infer<typeof TodoStatusSchema>;

export const TodoSchema = z
  .object({
    id: z.string().min(1),
    text: z.string().min(1).max(TODO_TEXT_MAX_CHARS),
    status: TodoStatusSchema,
    updatedAt: z.number().int().nonnegative(),
  })
  .strict();
export type Todo = z.infer<typeof TodoSchema>;

export const TodoListResponseSchema = z.object({ todos: z.array(TodoSchema) }).strict();
export type TodoListResponse = z.infer<typeof TodoListResponseSchema>;
